export default __webpack_public_path__ + "static/media/download.da7b9cdf.svg";